import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { IEpGridModel, EpEventService, EpGridEvent, IEpGridSelectionOptions, EpButtonStyle, IEpComponentEventArg, EpDialogService, EpDialogSize } from '@epicor/kinetic';
import { BistrackConfig, CustomEvents } from 'ep-bt-controls';
import { FieldAgentClient } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { EpbtFaImageDialogComponent } from '../../dialogs/epbt-fa-image-dialog/epbt-fa-image-dialog.component';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-product-files-grid',
  templateUrl: './epbt-fa-product-files-grid.component.html',
  styleUrls: ['./epbt-fa-product-files-grid.component.scss']
})
export class EpbtFaProductFilesGridComponent implements OnInit {
  gridModel: IEpGridModel;
  pageSize = 10;
  private _searchString: string;
  fileNameWithPath: string;
  imageData: string;
  @ViewChild('downloadDocumentCellTemplate', {static: true}) downloadTemplate: TemplateRef<any>;
  @ViewChild('byteTemplate', {static: true}) byteTemplate: TemplateRef<any>;

  constructor(private client: FieldAgentClient, private router: Router,
    private config: BistrackConfig, public epEvent: EpEventService, private fieldAgentService: EpbtFieldAgentService,
    private productService: EpbtFaProductService, private location: Location) {
  }

  ngOnInit() {
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.pageSize = bistrackSettings.searchPageSize;
      this.gridModel = this.getGridModel();
      this.getGridData();
    });
  }


  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'name',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: false,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      columns: [
        { field: 'name', title: 'FILE NAME', width: 60, hidden: false },
        { field: 'size', title: 'SIZE', width: 10, hidden: false, cellTemplate: this.byteTemplate },
        { field: 'url', title: 'VIEW/DOWNLOAD', width: 10, hidden: false, class: 'color-blue', cellTemplate: this.downloadTemplate },
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          // this.navigateBackToQuickPurchase(eventArg.event.dataItem);
        }
      },
    };
    return model;
  }

  // grid height calculation start

  getHeight(): number {
    const height = $(window).outerHeight() - 290;
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }

    return height;
  }

  getGridData() {
    this.client.getFileInformationSQL(this.productService.selectedProductItem.productId).subscribe(res => {
      if (res != null) {
        this.gridModel.data = res;
      }
    });
  }

  onDocumentDownloadClick(selectedDataItems: any) {
    const dialog = EpDialogService.progress({ message: selectedDataItems.name, description: ' Downloading...' });
    this.client.getProductFileStream(this.productService.selectedProductItem.productId, selectedDataItems.name).subscribe(resultBlob => {
      if (resultBlob && resultBlob.fileByte) {
        const resBlob = resultBlob.fileByte;
        if (selectedDataItems.name.toLocaleLowerCase().includes('.png')) {
          this.imageData = 'data:image/png;base64,' + resBlob;
          EpDialogService.custom({
            title: 'Attachment',
            component: EpbtFaImageDialogComponent,
            size: EpDialogSize.Large,
            data: this.imageData,
          });
        } else if (selectedDataItems.name.toLocaleLowerCase().includes('.jpeg')) {
          this.imageData = 'data:image/jpeg;base64,' + resBlob;
          EpDialogService.custom({
            title: 'Attachment',
            component: EpbtFaImageDialogComponent,
            size: EpDialogSize.Large,
            data: this.imageData,
          });
        } else if (selectedDataItems.name.toLocaleLowerCase().includes('.jpg')) {
          this.imageData = 'data:image/jpg;base64,' + resBlob;
          EpDialogService.custom({
            title: 'Attachment',
            component: EpbtFaImageDialogComponent,
            size: EpDialogSize.Large,
            data: this.imageData,
          });
        } else if (selectedDataItems.name.toLocaleLowerCase().includes('.txt')) {
          const contentType = `text/plain`;
          const blob = this.convertBase64ToBlob(resBlob, contentType);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        } else if (selectedDataItems.name.toLocaleLowerCase().includes('.pdf')) {
          const contentType = `application/pdf`;
          const blob = this.convertBase64ToBlob(resBlob, contentType);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        } else if (selectedDataItems.name.toLocaleLowerCase().includes('.mp3')) {
          const contentType = `audio/mpeg`;
          const blob = this.convertBase64ToBlob(resBlob, contentType);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        } else if (selectedDataItems.name.toLocaleLowerCase().includes('.html')) {
          const contentType = `text/html`;
          const blob = this.convertBase64ToBlob(resBlob, contentType);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        } else if (selectedDataItems.name.toLocaleLowerCase().includes('.xml')) {
          const contentType = `application/xml`;
          const blob = this.convertBase64ToBlob(resBlob, contentType);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        } else {
          const fileExtension = selectedDataItems.extension.split('.').join('').trim();
          const fileType: string = 'data:application/' + fileExtension + ';base64,';
          const linkSource = fileType + resBlob;
          const downloadLink = document.createElement('a');
          downloadLink.target = '_blank';
          const fileName = selectedDataItems.name;
          downloadLink.download = fileName;
          downloadLink.href = linkSource;
          downloadLink.setAttribute('visibility', 'hidden');
          downloadLink.click();
        }
        dialog.close();
      }
    });
  }

  convertBase64ToBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

}
